/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export interface LabeledInputProps extends React.ComponentPropsWithoutRef<'label'> {
    label?: React.ReactNode;
}

export const LabeledInput: React.FC<LabeledInputProps> = ({
    label = '',
    className,
    children,
    ...rest
}) => {
    if (!children) return null;

    return (
        <div className={cx('custom-control', className)}>
            {children}
            <label {...rest} className="custom-control-label">
                {label}
            </label>
        </div>
    );
};

LabeledInput.displayName = 'LabeledInput';
LabeledInput.propTypes = {
    label: PropTypes.node,
    className: PropTypes.string,
    children: PropTypes.node,
};
